import { useEffect, useState } from "react";
import { MessageSquare, Eye, EyeOff, Star } from "lucide-react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "../../lib/api";

function ReviewRow({ r, onChanged }) {
  const [reply, setReply] = useState(r.reply || "");
  const [busy, setBusy] = useState(false);
  const key = `${r.product_id}-${r.user_email}`;
  const save = async (patch) => {
    setBusy(true);
    try { await api.put("/admin/reviews", { product_id: r.product_id, user_email: r.user_email, ...patch }); toast.success("Recensione aggiornata"); onChanged(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className={`border border-stone-200 rounded-xl p-4 ${r.hidden ? "opacity-60 bg-stone-50" : "bg-white"}`} data-testid={`admin-review-${key}`}>
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <div className="text-xs text-stone-500">{r.product_name} · {new Date(r.created_at).toLocaleDateString("it-IT")}</div>
          <div className="flex items-center gap-2 mt-1"><span className="font-semibold text-[#0B2A45]">{r.user_name}</span><span className="text-xs text-stone-400">{r.user_email}</span>
            <span className="inline-flex items-center gap-0.5 text-xs text-[#EAB308]">{r.rating}<Star className="w-3 h-3 fill-current" /></span></div>
          {r.text && <p className="text-sm text-stone-700 mt-1">"{r.text}"</p>}
        </div>
        <Button size="sm" variant="outline" className="rounded-full" disabled={busy} onClick={() => save({ hidden: !r.hidden })} data-testid={`admin-review-toggle-${key}`}>
          {r.hidden ? <><Eye className="w-3.5 h-3.5 mr-1" />Mostra</> : <><EyeOff className="w-3.5 h-3.5 mr-1" />Nascondi</>}
        </Button>
      </div>
      <div className="mt-3 flex flex-col sm:flex-row gap-2">
        <Textarea rows={2} value={reply} onChange={(e) => setReply(e.target.value)} placeholder="Risposta pubblica del titolare…" className="flex-1 text-sm" data-testid={`admin-review-reply-${key}`} />
        <Button className="rounded-full bg-[#0F4C81] text-white sm:self-end" disabled={busy || reply === (r.reply || "")} onClick={() => save({ reply })} data-testid={`admin-review-reply-save-${key}`}>
          <MessageSquare className="w-4 h-4 mr-1" />{r.reply ? "Aggiorna risposta" : "Rispondi"}
        </Button>
      </div>
    </div>
  );
}

export default function ReviewsAdminPanel() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/reviews").then(({ data }) => setRows(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-6" data-testid="reviews-admin-panel">
      <div className="flex items-center gap-2 mb-5">
        <Star className="w-5 h-5 text-[#EAB308]" />
        <h3 className="font-serif text-xl font-semibold text-[#0B2A45]">Recensioni prodotti <span className="text-sm text-stone-400 font-sans">({rows.length})</span></h3>
      </div>
      {rows.length === 0 ? <p className="text-sm text-stone-400" data-testid="reviews-admin-empty">Nessuna recensione ancora.</p>
        : <div className="space-y-3">{rows.map((r) => <ReviewRow key={`${r.product_id}-${r.user_email}`} r={r} onChanged={load} />)}</div>}
    </div>
  );
}
